import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Platform } from "@ionic/angular";
import { Subject, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { GlobalsService } from "src/app/api/globals.service";
import { StorageService } from "src/app/services/storage.service";
import { TimerService } from "src/app/services/timer.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-pregunta-abierta",
  templateUrl: "./pregunta-abierta.component.html",
  styleUrls: ["./pregunta-abierta.component.scss"],
})
export class PreguntaAbiertaComponent implements OnInit {
  @Input() public DATA: any;
  @Input() public curso: any;
  @Input() public ID_TIPO_LC: any;
  @Output() public isvalid = new EventEmitter<boolean>();
  @Output() public name = new EventEmitter<string>();

  sqliteStorage: boolean = false;
  sqliteStorageData: any = null;
  inicio_actividad_key: string;
  ismobile: boolean;
  host: string;
  private readonly table = "actividades_respuestas_data";
  constructor(
    private storageService: StorageService,
    private platform: Platform,
    public globalsService: GlobalsService,
    private sanitizer: DomSanitizer,
    private timerService: TimerService
  ) {}

  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;

  debounceTime = 1000;
  private ID_TIPO = 8;
  private ID_ACTIVIDAD = 0;
  public activityCourse: any;
  public explicacion: string = "";
  public respuesta: string = "";
  recurso: any;
  ngOnInit() {
    this.host = environment.host + "/";
    this.name.emit("Pregunta Abierta");
    if (this.DATA.tipo_recurso === "img") {
      this.recurso = this.host + this.DATA.recurso;
    } else {
      this.recurso = this.embedVideo(this.DATA.recurso);
    }
    this.explicacion = this.DATA.explicacion;
    this.ID_ACTIVIDAD = this.DATA.id_actividad;

    let _id_librocurso = this.ID_ACTIVIDAD;
    let id_tipo = this.ID_TIPO;
    let id_ejercicio = this.DATA.id;
    let _id_curso = this.curso.id;
    let _tipo = this.ID_TIPO_LC;
    let _id_user = this.curso.id_user;
    const key = `inicio_actividad_${_id_curso}_${_id_librocurso}_${_id_user}_${_tipo}_${id_ejercicio}_${id_tipo}`;
    console.log("DATA ->KEY:", key);
    this.inicio_actividad_key = key;
    this.platform.ready().then(() => {
      this.getStorage();
    });
    this.subscription = this.modelChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => {
        this.saveText();
      });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  saveText() {
    this.Storage(this.respuesta);
  }

  CommentChange(event) {
    this.modelChanged.next(this.respuesta);
  }
  async getStorage() {
    let activityCourse: any;
    /**************************** */
    this.storageService.get("activities").then((res: any) => {
      if (res) {
        activityCourse = res.find(
          (x) => x.id_actividad == this.ID_ACTIVIDAD && x.id == this.curso.id
        );
        activityCourse.data.forEach((element2, j) => {
          if (
            element2.id == this.DATA.id &&
            element2.id_actividad == this.ID_ACTIVIDAD &&
            element2.id_tipo == this.ID_TIPO
          ) {
            this.respuesta = element2.respuesta.r;
            this.timerService.initTimer(element2.timer);
            this.isvalid.emit(true);
          }
        });

        this.Storage(this.respuesta);
      }
    });
  }

  Storage(respuesta: any) {
    if (this.respuesta && this.respuesta.trim().length > 0) {
      this.isvalid.emit(true);
    } else {
      this.isvalid.emit(false);
    }
    this.storageService
      .get("activities")
      .then((res) => {
        if (res) {
          this.activityCourse = res;
          this.activityCourse.forEach((element, i) => {
            if (
              element.id == this.curso.id &&
              element.id_actividad == this.ID_ACTIVIDAD
            ) {
              let data: any;
              data = {
                id: this.DATA.id,
                id_actividad: this.DATA.id_actividad,
                id_tipo: this.DATA.id_tipo,
                respuesta: {
                  r: respuesta,
                },
              };
              if (element.data.length == 0) {
                element.data.push(data);
              } else {
                let find: boolean = false;
                element.data.forEach((element2, j) => {
                  if (
                    element2.id_tipo == this.DATA.id_tipo &&
                    element2.id == this.DATA.id
                  ) {
                    element.data[j] = data;
                    find = true;
                  }
                });
                if (!find) {
                  element.data.push(data);
                }
              }
            }
          });
          this.storageService.storage("activities", this.activityCourse);
        } else {
          let data: any;
          data = {
            id: this.DATA.id,
            id_actividad: this.DATA.id_actividad,
            id_tipo: this.DATA.id_tipo,
            respuesta: {
              r: respuesta,
            },
          };
          this.storageService.storage("activities", this.activityCourse);
        }
      })
      .catch((err) => {
        console.log("storageService error", err);
      });
    /************************************* */
  }

  embedVideo(url) {
    const youtubeRegex =
      /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    if (youtubeRegex.test(url)) {
      const videoId = url.match(youtubeRegex)[1];
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${videoId}`
      );
    } else {
      return null;
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    alert("El pegado no está permitido");
  }

  onKeyDown(event: KeyboardEvent) {
    // Bloquea Ctrl+V (Windows) y Cmd+V (Mac)
    if ((event.ctrlKey || event.metaKey) && event.key === "v") {
      event.preventDefault();
      alert("El pegado no está permitido");
    }
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }
}
